import { render, staticRenderFns } from "./MFALogin.vue?vue&type=template&id=bc40c730&scoped=true&"
import script from "./MFALogin.vue?vue&type=script&lang=ts&"
export * from "./MFALogin.vue?vue&type=script&lang=ts&"
import style0 from "./MFALogin.vue?vue&type=style&index=0&id=bc40c730&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc40c730",
  null
  
)

export default component.exports